export { default } from "./ProfileDetails";
